import type { Annotations } from 'chessboard/model/annotation/types';
import { isNagFormat } from 'chessboard/model/annotation/is-nag-format';
import { nagMap, invertedNagMap } from 'chessboard/model/annotation/config';

/**
 * Normalize an annotation to support nag or convert from normal symbol back to nag
 * and then to a readable symbol. If no nag is found, the passed string is returned.
 * If it's undefined or null, an empty string is returned.
 *
 * Generally useful when importing two types of annotations (1. e4!) or (1. e4$1)
 */
export function normalizeAnnotation(
  annotation?: Annotations.Nags | Annotations.Values | string,
): string | Annotations.Values {
  if (
    !annotation ||
    (!Object.prototype.hasOwnProperty.call(nagMap, annotation) &&
      !Object.prototype.hasOwnProperty.call(invertedNagMap, annotation))
  ) {
    return annotation || '';
  }

  if (isNagFormat(annotation)) {
    return nagMap[<Annotations.Nags>annotation];
  }

  return normalizeAnnotation(invertedNagMap[annotation]);
}
